import { createContext, useContext, useState } from 'react';

// Create the navigation context
const NavContext = createContext();

// Custom hook to use the navigation context
export function useNav() {
  return useContext(NavContext);
}

// Provider component for the navigation context
export function NavProvider({ children }) {
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Function to open a dropdown and close any other open dropdown
  const openDropdown = (dropdownId) => {
    setActiveDropdown(dropdownId);
  };

  // Function to close a dropdown
  const closeDropdown = (dropdownId) => {
    if (activeDropdown === dropdownId) {
      setActiveDropdown(null);
    }
  };

  // Function to toggle a dropdown
  const toggleDropdown = (dropdownId) => {
    if (activeDropdown === dropdownId) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdownId);
    }
  };

  // Check if a dropdown is currently active
  const isDropdownActive = (dropdownId) => {
    return activeDropdown === dropdownId;
  };

  // Context value
  const value = {
    activeDropdown,
    openDropdown,
    closeDropdown,
    toggleDropdown,
    isDropdownActive,
  };

  return <NavContext.Provider value={value}>{children}</NavContext.Provider>;
}

